import useCollectionsOnlyForContext from '@/hooks/collections/useCollectionsOnlyForContext';
import { createContext } from 'react';

// Context that provides all the Collections data functionality
const CollectionsContext = createContext<
	ReturnType<typeof useCollectionsOnlyForContext>
>({
	collections: undefined,
	collectionsSortedByCollectedCards: [],
	findCollectionsOfSpeciesId: () => [],
	isLoading: false,
	error: undefined,
});

export default CollectionsContext;
